export const courses = r => require.ensure([], () => r(require('../components/list/courses')), 'report-bundle')
export const Reports = r => require.ensure([], () =>
                                r(require('../components/reports/index')), 'report-bundle')
export const Learners = r => require.ensure([], () =>
                                r(require('../components/reports/learners')), 'report-bundle')
export const Departments = r => require.ensure([], () =>
                                r(require('../components/reports/departments')), 'report-bundle')
export const Courses = r => require.ensure([], () => r(require('../components/reports/courses')), 'report-bundle')

export const DepartmentTargets = r => require.ensure([], () => r(require('../components/reports/department_targets')), 'report-bundle')
export const TargetCourses = r => require.ensure([], () => r(require('../components/reports/target_courses')), 'report-bundle')


export const Emaillogs = r => require.ensure([], () => r(require('../components/logs/index')), 'report-bundle')
export const Teamslogs = r => require.ensure([], () => r(require('../components/logs/teams')), 'report-bundle')
export const Exported = r => require.ensure([], () => r(require('../components/reports/exported_files')), 'report-bundle')
export const Approvals = r => require.ensure([], () => r(require('../components/approvals/index')), 'report-bundle')
export const ApprovalDetail = r => require.ensure([], () => r(require('../components/approvals/detail')), 'report-bundle')



// WEBPACK FOOTER //
// ./src/app/lms/routes/components.js